// extracted by mini-css-extract-plugin
export default {"orderList":"userorderlist_orderList__mjnDP"};